import produce from 'immer';
import { ADD_USER_REQUEST, ADD_USER_SUCCESS, ADD_USER_FAILURE, IMPORT_EXCEL_REQUEST, IMPORT_EXCEL_SUCCESS, IMPORT_EXCEL_FAILURE, DOWNLOAD_EXCEL_TEMPLATE_REQUEST, DOWNLOAD_EXCEL_TEMPLATE_SUCCESS, DOWNLOAD_EXCEL_TEMPLATE_FAILURE, } from './constants';
export var initialState = {
    loading: false,
    error: false,
    templateLoading: false,
    templateError: false,
    createdUsers: [],
};
function userNewReducer(currentState, action) {
    if (currentState === void 0) { currentState = initialState; }
    return produce(currentState, function (state) {
        switch (action.type) {
            case ADD_USER_REQUEST:
                state.loading = true;
                state.error = false;
                break;
            case ADD_USER_SUCCESS:
                state.loading = false;
                state.error = false;
                state.createdUsers = action.createdUsers;
                break;
            case ADD_USER_FAILURE:
                state.loading = false;
                state.error = true;
                break;
            case IMPORT_EXCEL_REQUEST:
                state.loading = true;
                state.error = false;
                break;
            case IMPORT_EXCEL_SUCCESS:
                state.loading = false;
                state.error = false;
                state.createdUsers = action.createdUsers;
                break;
            case IMPORT_EXCEL_FAILURE:
                state.loading = false;
                state.error = true;
                break;
            case DOWNLOAD_EXCEL_TEMPLATE_REQUEST:
                state.templateLoading = true;
                state.templateError = false;
                break;
            case DOWNLOAD_EXCEL_TEMPLATE_SUCCESS:
                state.templateLoading = false;
                state.templateError = false;
                break;
            case DOWNLOAD_EXCEL_TEMPLATE_FAILURE:
                state.templateLoading = false;
                state.templateError = true;
                break;
            default:
                break;
        }
    });
}
export default userNewReducer;
